module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListItem",
    on: {
      "click": function($event) {
        _vm.click($event.target)
      }
    }
  }, [_c('div', {
    staticClass: "ListItem__icon"
  }, [_c('i', {
    class: [_vm.sex === 1 ? 'icon-male' : 'icon-female']
  })]), _vm._v(" "), _c('div', {
    staticClass: "ListItem__header"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListItem__icon-right"
  }, [_c('i', {
    staticClass: "icon-angle-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17165661"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/ListItem.vue
// module id = 570
// module chunks = 1